import script from "./CopywritingData.vue?vue&type=script&setup=true&lang=js"
export * from "./CopywritingData.vue?vue&type=script&setup=true&lang=js"

import "./CopywritingData.vue?vue&type=style&index=0&id=a0e19e70&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0e19e70"]])

export default __exports__